import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=3b4f7e01&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=ts&"
export * from "./ContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=3b4f7e01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f7e01",
  null
  
)

export default component.exports